import workspace from "./workspace";
import { allowedOrganizations } from "@/utils/workspaceOrganisations";
import { useStore } from "@/store";

export const getOrgs = async () => {
  const userOrg = useStore.userOrg();
  const  params =  { org_name: userOrg };

  try {
    const response = await workspace.get("/organization/", { params });
    return allowedOrganizations(response.data);
  } catch (error) {
    console.error("Error fetching rate limit:", error);
    throw error;
  }
};


export const getOrgbyID = async (id) => {
  try {
    const userOrg = useStore.userOrg();
    const  params =  { org_name: userOrg };
    const response = await workspace.get(`/organization/${id}`, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching rate limit:", error);
    throw error;
  }
};


export const createwsOrg = async (orgData) => {
  try {
    const response = await workspace.post("/organization/", orgData);
    return response.data;
  } catch (error) {
    console.error("Error creating organization:", error);
    throw error;
  }
}

export const updatewsOrg = async (orgId, orgData) => {
  try {
    const response = await workspace.put(`/organization/${orgId}/`, orgData);
    return response.data;
  } catch (error) {
    console.error(`Error updating organization with ID ${orgId}:`, error);
    throw error;
  }
};

export const deletewsOrg = async (orgId, orgData) => {
  try {
    const response = await workspace.delete(`/organization/${orgId}/`, orgData);
    return response.data;
  } catch (error) {
    console.error(`Error updating organization with ID ${orgId}:`, error);
    throw error;
  }
};